import { Content } from "pdfmake/interfaces";
import { date, il, set, currency_png } from "report/common/icon";
import layout from "report/common/layout";
import getTitle from "report/common/title";
import appliedFilter from "./applied-filter";

const withWrapHintsForLongAsciiTokens = (value: string): string => {
  return value.replace(/[A-Za-z0-9._\/-]{20,}/g, (token) =>
    token.replace(/(.{12})/g, "$1 ")
  );
};

const get = (
  t: any,
  name: string,
  count: number,
  locationsFilterInfo: any[],
  currency: string
): Content[] => {
  const parts: Content[] = [
    getTitle(t("report.Report Details")),
    {
      table: {
        headerRows: 0,
        widths: ["auto", "*", "*"],
        body: [
          [
            {
              image: set,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("report.Location Set"), opacity: 0.6 },
            {
              text: withWrapHintsForLongAsciiTokens(name),
              noWrap: false
            }
          ],
          [
            {
              image: il,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("report.Total Locations"), opacity: 0.6 },
            `${count}`
          ],
          [
            {
              image: date,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("report.date"), opacity: 0.6 },
            new Date().toLocaleString()
          ],
          [
            {
              image: currency_png,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("locations.add.currency"), opacity: 0.6 },
            currency
          ]
        ]
      },
      layout: layout(),
      fontSize: 8
    }
  ];

  const af = appliedFilter(t, locationsFilterInfo); // Content | undefined
  if (af) parts.push(af);

  return parts;
};

export default get;
